var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: -0.236,
    y2: 1.193,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e39a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#9f4693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78728"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(-962 -11821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17468",
    "data-name": "Path 17468",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(962 11821)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(972.499 11831.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M10.722,5.838A4.876,4.876,0,1,0,15.6,10.714a4.875,4.875,0,0,0-4.876-4.876Zm0,8.04a3.165,3.165,0,1,1,3.165-3.165A3.164,3.164,0,0,1,10.722,13.878Z",
    transform: "translate(-1.217 -1.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M13.419.06C11.671-.021,7.34-.017,5.591.06A5.678,5.678,0,0,0,1.6,1.6C-.224,3.424.009,5.887.009,9.5c0,3.7-.206,6.1,1.594,7.9,1.835,1.834,4.333,1.594,7.9,1.594,3.661,0,4.925,0,6.219-.5,1.76-.683,3.089-2.257,3.219-5.082.082-1.749.078-6.078,0-7.828C18.785,2.248,17,.225,13.419.06Zm2.767,16.13c-1.2,1.2-2.86,1.091-6.7,1.091-3.959,0-5.546.059-6.7-1.1-1.334-1.328-1.093-3.46-1.093-6.693,0-4.374-.449-7.525,3.941-7.75C6.634,1.7,6.931,1.688,9.47,1.688l.036.024c4.219,0,7.53-.442,7.728,3.948.045,1,.055,1.3.055,3.838,0,3.913.074,5.51-1.1,6.693Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1.139,
    cy: 1.139,
    r: 1.139,
    transform: "translate(13.434 3.291)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.bd27af062269ca7fa54c89c9298f3c5a.svg";
export { ForwardRef as ReactComponent };